export default "__VITE_ASSET__DFXpK66w__"